import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'custom_roles_wrapper',
          // Montar papel é entregar permissão, então quem monta pode se promover: só
          // `administrator`, sem permissão nomeada que delegue isto. Mesmo corte do
          // `CustomRolePolicy` no backend.
          meta: {
            permissions: ['administrator'],
            // ACESSO-01 (L8b): montar papel (`custom_roles#*`), que não se concede: o modelo Administrador.
            escopos: ['roles:manage'],
          },
          redirect: to => {
            return { name: 'custom_roles_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'custom_roles_list',
          meta: {
            permissions: ['administrator'],
            // ACESSO-01 (L8b): montar papel (`custom_roles#*`), que não se concede: o modelo Administrador.
            escopos: ['roles:manage'],
          },
          component: Index,
        },
      ],
    },
  ],
};
